import { render, staticRenderFns } from "./LanguageEmployeeSettingView.vue?vue&type=template&id=e996bb52&scoped=true&"
import script from "./LanguageEmployeeSettingView.vue?vue&type=script&lang=js&"
export * from "./LanguageEmployeeSettingView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e996bb52",
  null
  
)

export default component.exports